export default {
  products: [],
  points: {},
  ewallets: [],
  poincashs: [],
  rebates: [],

  product: [],
  ewallet: [],
  poincash: [],
  rebate: [],
  pulsa: [],

  cart: [],
  cartEwallet: [],
  cartPoincash: [],
  cartRebate: [],
  cartPulsa: []
};
